"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _QuestionCircle = _interopRequireDefault(require("../../icons-react/QuestionCircle"));
var _Bubble = _interopRequireDefault(require("../Bubble"));
var _tagTypes = require("./utils/tagTypes");
var _styles = require("./utils/styles");
var HotelCardTag = function HotelCardTag(_ref) {
  var _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text,
    type = _ref.type,
    className = _ref.className,
    tooltipText = _ref.tooltipText;
  var tagBody = type ? _tagTypes.TYPES[type] : undefined;
  var tagTooltip = tooltipText || (tagBody === null || tagBody === void 0 ? void 0 : tagBody.tooltipText) || '';
  var icon = tagBody === null || tagBody === void 0 ? void 0 : tagBody.icon;
  return /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
    disabled: !tagTooltip,
    text: tagTooltip
  }, /*#__PURE__*/_react["default"].createElement(StyledHotelCardTag, {
    $type: type,
    className: className
  }, icon && /*#__PURE__*/_react["default"].createElement(IconWrapper, null, icon), /*#__PURE__*/_react["default"].createElement("div", null, text || (tagBody === null || tagBody === void 0 ? void 0 : tagBody.text)), tagTooltip && /*#__PURE__*/_react["default"].createElement(StyledQuestionCircle, {
    tooltipColor: tagBody === null || tagBody === void 0 ? void 0 : tagBody.tooltipColor
  })));
};
var IconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardTag__IconWrapper",
  componentId: "sc-1eqasib-0"
})(["margin:0 4px;line-height:0;svg{fill:none;stroke-width:1;}"]);
var StyledHotelCardTag = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardTag__StyledHotelCardTag",
  componentId: "sc-1eqasib-1"
})(["height:22px;border-radius:5px;padding:0 8px;display:flex;align-items:center;background-color:#e6e9ee;font-size:13px;cursor:default;", ";", ""], function (_ref2) {
  var $type = _ref2.$type;
  return $type === 'trustYou' && "\n      padding-left: 4px;\n      background: none;\n      color: #4b137b;\n      height: 16px;\n    ";
}, function (_ref3) {
  var $type = _ref3.$type;
  return _styles.TYPES_COLOR[$type || 'default'];
});
var StyledQuestionCircle = (0, _styledComponents["default"])(_QuestionCircle["default"]).withConfig({
  displayName: "HotelCardTag__StyledQuestionCircle",
  componentId: "sc-1eqasib-2"
})(["width:16px;height:16px;stroke:none;circle{stroke:", ";}path{fill:", ";}margin-left:4px;"], function (_ref4) {
  var tooltipColor = _ref4.tooltipColor;
  return tooltipColor;
}, function (_ref5) {
  var tooltipColor = _ref5.tooltipColor;
  return tooltipColor;
});
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(HotelCardTag);